// extracted by mini-css-extract-plugin
module.exports = {"title_box":"title_box-3fRCTuc-","title":"title-2A_2oOy6","title1":"title1-xsM20Iwz","current":"current-2aHao7wE"};